import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.array.fill";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.some";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.assign";

/**
  *
  * TypeIt - React
  * Author: Alex MacArthur <alex@macarthur.me> (https://macarthur.me)
  * Version: v0.0.3
  * License: GPL-2.0
  * URL: https://typeitjs.com
  *
  */
import { createElement as t, useRef as e, useEffect as n, useState as i, useMemo as r } from "react";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var _o = function o() {
  return (_o = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
};

function s(t) {
  return (s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
    return typeof t;
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  })(t);
}

var u = {
  strings: [],
  speed: 100,
  cursor: !0,
  cursorChar: "|",
  cursorSpeed: 1e3,
  deleteSpeed: null,
  lifeLike: !0,
  breakLines: !0,
  startDelay: 250,
  startDelete: !1,
  nextStringDelay: 750,
  loop: !1,
  loopDelay: 750,
  html: !0,
  waitUntilVisible: !1,
  beforeString: function beforeString() {},
  afterString: function afterString() {},
  beforeStep: function beforeStep() {},
  afterStep: function afterStep() {},
  afterComplete: function afterComplete() {}
};

function a() {
  var t = this,
      e = this,
      n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
      i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
  this.insert = function (e, n) {
    t.waiting.splice(e, 0, n);
  }, this.add = function (t) {
    var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    return Array.isArray(t[0]) ? (e.waiting = e.waiting.concat(t), e) : (e.waiting[n ? "unshift" : "push"](t), e);
  }, this["delete"] = function (e) {
    return t.waiting.splice(e, 1), t;
  }, this.reset = function () {
    return t.waiting = t.executed.concat(t.waiting), t.executed = [], t;
  }, this.executed = [], this.waiting = n, !n.length && i && this.add(i);
}

var c = function c(t) {
  return document.createElement(t);
};

function l(t, e) {
  return Math.abs(Math.random() * (t + e - (t - e)) + (t - e));
}

function f(t) {
  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
      n = c("style");
  n.id = e, n.appendChild(document.createTextNode(t)), document.head.appendChild(n);
}

function h(t) {
  return t.map(function (t) {
    return t.replace(/<\!--.*?-->/g, "");
  });
}

var p = function p(t) {
  return ["textarea", "input"].indexOf(t.tagName.toLowerCase()) > -1;
},
    d = function d(t) {
  return Array.isArray(t) ? t : [t];
},
    v = function v(t) {
  return [].slice.call(t);
},
    y = function y(t, e) {
  var n = t.nextSibling;
  return !!n && !n.isEqualNode(e);
},
    g = function g(t, e) {
  var n = e;
  if (p(t)) t.value = "".concat(t.value).concat(n);else {
    var i = v(t.childNodes).filter(function (t) {
      return t.classList && t.classList.contains("ti-cursor");
    });

    if (i = i.length ? i[0] : null, "object" == s(e) && !(e instanceof HTMLElement)) {
      var r = e.ancestorTree.slice(0).reverse().join(" "),
          o = v(t.querySelectorAll("".concat(r))),
          u = (o = o.filter(function (t) {
        return !i || !i.isEqualNode(t);
      })).length > 0 ? o[o.length - 1] : null;
      if (u && function (t, e) {
        if (!t) return !1;

        for (var n = !1, i = [], r = t; !n;) {
          i.push(y(r, e)), (r = r.parentNode) && r.hasAttribute && !r.hasAttribute("data-typeit-id") || (n = !0);
        }

        return !i.some(function (t) {
          return t;
        });
      }(u, i)) t = u, n = e.content;else if (n = function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
            i = c(t);
        return e.forEach(function (t) {
          i.setAttribute(t.name, t.value);
        }), i.innerHTML = n, i;
      }(e.ancestorTree[0], e.attributes, e.content), e.ancestorTree.length > 1) {
        var a = v(t.querySelectorAll(e.ancestorTree[1]));
        t = a[a.length - 1];
      }
    }

    n = "object" == s(n) ? n : document.createTextNode(n), t.insertBefore(n, i && t.hasAttribute("data-typeit-id") ? i : null);
  }
},
    m = function m(t) {
  var e = [];
  return e.concat.apply(e, t);
},
    b = function b(t) {
  var e = document.implementation.createHTMLDocument("");
  return e.body.innerHTML = t, e.body;
},
    w = function w(t) {
  return v(t.childNodes).map(function (t) {
    return 3 === t.nodeType ? t.nodeValue.split("") : t;
  });
},
    S = function S(t, e, n) {
  return {
    ancestorTree: e,
    attributes: (i = t, v(i.attributes).map(function (t) {
      return {
        name: t.name,
        value: t.nodeValue
      };
    })),
    content: n
  };
  var i;
},
    q = function q(t, e) {
  var n = S(t, e, ""),
      i = w(t).map(function (n, i) {
    return Array.isArray(n) ? n.map(function (n, i) {
      return S(t, e, n);
    }) : n;
  });
  return i.unshift(n), m(i);
},
    A = function A(t) {
  return t instanceof HTMLElement && "BR" !== t.tagName;
},
    T = function t(e) {
  var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
      i = e.map(function (t) {
    if (A(t)) {
      if (!n) return v(t.childNodes);

      for (var e = t.parentNode, i = [t.tagName]; ["BODY", "HTML"].indexOf(e.tagName) < 0;) {
        i.push(e.tagName), e = e.parentNode;
      }

      return q(t, i);
    }

    return t;
  });
  return (i = m(i)).some(function (t) {
    return A(t);
  }) ? t(i, n) : i;
};

function L(t) {
  var e = b(t),
      n = w(e);
  return T(n);
}

function N(t) {
  var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
  return e ? L(t) : t.split("");
}

var x = function x(t, e) {
  e ? t.value = "" : t.querySelector(".ti-cursor") && (t.innerHTML = "");
},
    O = function O(t, e) {
  var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
      i = !Array.isArray(t),
      r = t.length;
  return (t = i ? new Array(t).fill(0) : t).map(function (t, o) {
    if (i) return e;
    var s = [e, t];
    return n && (0 === o && s.push({
      isFirst: !0
    }), o + 1 === r && s.push({
      isLast: !0
    })), s;
  });
},
    E = function E(t) {
  t.parentNode.removeChild(t);
},
    D = function D(t) {
  return 3 !== t.nodeType && "BR" !== t.tagName && !t.firstChild;
},
    $ = function $(t) {
  return t.some(function (t) {
    return D(t);
  });
},
    M = function M(t) {
  for (var e = v(t.querySelectorAll("*")), n = $(e); e.length && n;) {
    var i = !1;
    e.forEach(function (t) {
      D(t) && (E(t), i = !0);
    }), i && (e = v(t.querySelectorAll("*"))), n = $(e);
  }

  return e;
},
    P = function P(t) {
  return Array.isArray(t) || (t = [t / 2, t / 2]), {
    before: t[0],
    after: t[1],
    total: t[0] + t[1]
  };
};

function I(t, e, n) {
  var i = (e = null !== e ? e : t / 3) / 2;
  return n ? [l(t, t / 2), l(e, i)] : [t, e];
}

function j() {
  var t = this,
      e = this,
      n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      i = n.typeIt,
      r = n.element,
      o = n.id,
      l = n.options,
      y = n.queue,
      m = void 0 === y ? [] : y,
      w = n.isAReset,
      S = void 0 !== w && w,
      q = function q() {
    var e = v(t.$e.childNodes).filter(function (t) {
      return !t.isEqualNode(k);
    });
    return T(e, !1);
  },
      A = function A(t) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
        i = e.opts.nextStringDelay;
    e.queue.insert(t, [e.pause, i.before]), e.queue.insert(t + n + 1, [e.pause, i.after]);
  },
      D = function D() {
    !B && t.opts.cursor && (f("@keyframes blink-".concat(o, " { 0% {opacity: 0} 49% {opacity: 0} 50% {opacity: 1} }[data-typeit-id='").concat(o, "'] .ti-cursor { animation: blink-").concat(o, " ").concat(t.opts.cursorSpeed / 1e3, "s infinite; }"), o), (k = c("span")).innerHTML = b(t.opts.cursorChar).innerHTML, k.className = "ti-cursor", k.setAttribute("style", "display:inline;position:relative;font:inherit;color:inherit;line-height:inherit;"), t.$e.appendChild(k));
  };

  this.wait = function (t, e) {
    this.timeouts.push(setTimeout(t, e));
  };

  var $ = function $() {
    t.opts.strings.forEach(function (e, n) {
      var i = N(e, t.opts.html);
      t.queue.add(O(i, t.type, !0));
      var r = t.queue.waiting.length;

      if (n + 1 !== t.opts.strings.length) {
        if (t.opts.breakLines) return t.queue.add([t.type, c("BR")]), void A(r);
        t.queue.add(O(i, t["delete"])), A(r, e.length);
      }
    });
  },
      C = function C(e) {
    t.queue.reset()["delete"](0).add([t.pause, e.before], !0);

    for (var n = 0; n < q().length; n++) {
      t.queue.add([t["delete"], null, {
        isPhantom: !0
      }], !0);
    }
  },
      H = function H(e) {
    var n = t.$e.innerHTML;
    return n ? (t.$e.innerHTML = "", t.opts.startDelete ? (L(n).forEach(function (e) {
      g(t.$e, e);
    }), t.queue.add([t["delete"], !0]), A(1), e) : [n.trim()].concat(e)) : e;
  };

  this.pause = function () {
    var t = this,
        e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
    return new Promise(function (n, i) {
      t.wait(function () {
        return n();
      }, e || t.opts.nextStringDelay.total);
    });
  }, this.reset = function () {
    return this.queue.reset(), new j({
      typeIt: i,
      element: this.$e,
      id: o,
      options: this.opts,
      queue: this.queue.waiting,
      isAReset: !0
    });
  }, this.init = function () {
    var t = this;

    if (!this.status.started) {
      if (D(), !this.opts.waitUntilVisible) return this.status.started = !0, this.fire();
      new IntersectionObserver(function (e, n) {
        e.forEach(function (e) {
          e.isIntersecting && (t.fire(), n.unobserve(t.$e));
        });
      }, {
        threshold: 1
      }).observe(this.$e);
    }
  }, this.fire = function () {
    for (var t = this, e = this, n = this.queue.waiting.slice(), r = Promise.resolve(), o = function o(t) {
      var o = n[t],
          s = [o, e.queue, i];
      r = r.then(function () {
        return new Promise(function (t, n) {
          var i, r;
          if (e.status.frozen) return n();
          e.pace = I(e.opts.speed, e.opts.deleteSpeed, e.opts.lifeLike), o[2] && o[2].isFirst && (i = e.opts).beforeString.apply(i, s), (r = e.opts).beforeStep.apply(r, s), o[0].call(e, o[1], o[2]).then(function () {
            var n,
                i,
                r = e.queue.waiting.shift();
            return o[2] && o[2].isPhantom ? t() : (o[2] && o[2].isLast && (n = e.opts).afterString.apply(n, s), (i = e.opts).afterStep.apply(i, s), e.queue.executed.push(r), t());
          });
        });
      });
    }, s = 0; s < n.length; s++) {
      o(s);
    }

    r.then(function () {
      if (t.opts.loop) {
        var e = t.opts.loopDelay ? t.opts.loopDelay : t.opts.nextStringDelay;
        t.wait(function () {
          C(e), t.fire();
        }, e.after);
      }

      t.status.completed = !0, t.opts.afterComplete(i);
    })["catch"](function () {});
  }, this.type = function (t) {
    var e = this;
    return "object" != s(t) || t.content ? new Promise(function (n) {
      e.wait(function () {
        return g(e.$e, t), n();
      }, e.pace[0]);
    }) : (g(this.$e, t), Promise.resolve());
  }, this.empty = function () {
    var t = this;
    return new Promise(function (e) {
      return B ? t.$e.value = "" : v(t.$e.childNodes).forEach(function (t) {
        k.isEqualNode(t) || E(t);
      }), e();
    });
  }, this["delete"] = function () {
    var t = this,
        e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
    return new Promise(function (n) {
      t.wait(function () {
        var i = q();
        return i.length && E(i[i.length - 1]), M(t.$e), e && i.length - 1 > 0 ? t["delete"](!0).then(function () {
          return n();
        }) : n();
      }, t.pace[1]);
    });
  }, this.setOptions = function (t) {
    var e = this;
    return new Promise(function (n) {
      return e.opts = Object.assign({}, e.opts, t), n();
    });
  };
  var k = null,
      B = p(r);
  this.status = {
    started: !1,
    complete: !1,
    frozen: !1,
    destroyed: !1
  }, this.$e = r, this.timeouts = [], this.opts = Object.assign({}, u, l), this.opts.html = !B && this.opts.html, this.opts.nextStringDelay = P(this.opts.nextStringDelay), this.opts.loopDelay = P(this.opts.loopDelay), this.queue = new a(m, [this.pause, this.opts.startDelay]), this.$e.setAttribute("data-typeit-id", o), f("[data-typeit-id]:before {content: '.'; display: inline-block; width: 0; visibility: hidden;}"), x(r, B);
  var R = d(this.opts.strings);
  R = H(R), this.opts.strings = h(R), this.opts.strings.length && !S && $();
}

function C(t, e) {
  var n,
      i = this,
      r = this;
  this.instances = (n = t, "string" == typeof n ? n = document.querySelectorAll(n) : n.forEach || (n = [n]), v(n)).map(function (t) {
    return new j({
      typeIt: i,
      element: t,
      id: Math.random().toString(36).substring(2, 15),
      options: e,
      queue: [],
      isAReset: !1
    });
  });

  var o = function o(t) {
    i.instances.forEach(function (e) {
      t.call(i, e);
    });
  },
      s = function s(t) {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
    o(function (i) {
      var o = "string" != typeof t,
          s = o ? t : i[t],
          u = O(n, [s, o ? r : e]);
      i.queue.add(u);
    });
  };

  this.is = function (t) {
    return e = this.instances, n = t, !0, !!e.length && !e.some(function (t) {
      return !0 !== t.status[n];
    });
    var e, n;
  }, this.freeze = function () {
    o(function (t) {
      t.status.frozen = !0;
    });
  }, this.unfreeze = function () {
    o(function (t) {
      t.status.frozen && (t.status.frozen = !1, t.fire());
    });
  }, this.type = function () {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
    return o(function (e) {
      var n = N(t, e.opts.html);
      e.queue.add(O(n, e.type, !0));
    }), this;
  }, this["delete"] = function () {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
    return s("delete", null === t, null === t ? 1 : t), this;
  }, this.pause = function () {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
    return s("pause", t), this;
  }, this["break"] = function () {
    return s("type", c("BR")), this;
  }, this.options = function (t) {
    return s("setOptions", t), this;
  }, this.exec = function (t) {
    return s(t), this;
  }, this.destroy = function () {
    var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
    this.instances = this.instances.map(function (e) {
      if (e.timeouts.forEach(function (t) {
        clearTimeout(t);
      }), e.timeouts = [], t) {
        var n = e.isInput ? null : e.$e.querySelector(".ti-cursor");
        n && e.$e.removeChild(n);
      }

      return e.status.destroyed = !0, e;
    });
  }, this.empty = function () {
    return s("empty"), this;
  }, this.reset = function () {
    return this.destroy(), this.instances = this.instances.map(function (t) {
      return t.reset();
    }), this;
  }, this.go = function () {
    return o(function (t) {
      t.init();
    }), this;
  };
}

var H = ["area", "base", "br", "col", "embed", "hr", "img", "input", "link", "meta", "param", "source", "track", "wbr"],
    k = e,
    B = n,
    R = i,
    z = r,
    V = function V(e) {
  var n = R(!0),
      i = n[0],
      r = n[1],
      s = k(null),
      u = e.options,
      a = e.element,
      c = e.children,
      l = e.getBeforeInit,
      f = e.getAfterInit,
      h = function (t, e) {
    var n = {};

    for (var i in t) {
      Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
    }

    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
      var r = 0;

      for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
        e.indexOf(i[r]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[r]) && (n[i[r]] = t[i[r]]);
      }
    }

    return n;
  }(e, ["options", "element", "children", "getBeforeInit", "getAfterInit"]),
      p = a,
      d = z(function () {
    return t = p, H.indexOf(t.toLowerCase()) > -1;
    var t;
  }, [p]);

  return B(function () {
    c && (u.strings = s.current.innerHTML), r(!1);
  }, []), B(function () {
    if (!i) {
      var t = new C(s.current, _o({}, u));
      return (t = l(t)).go(), t = f(t), function () {
        t.destroy();
      };
    }
  }, [i]), t("div", {
    style: {
      opacity: i ? 0 : 1
    }
  }, d ? t(p, _o({
    ref: s
  }, h)) : t(p, _o({
    ref: s
  }, h), i && c));
};

V.defaultProps = {
  element: "span",
  options: {},
  getBeforeInit: function getBeforeInit(t) {
    return t;
  },
  getAfterInit: function getAfterInit(t) {
    return t;
  }
};
export default V;